import React from "react";
import "../App.css"
import UserManuals from "./UserManuals";
const Home = () => {
  return (
    <UserManuals/>
  )
}
export default Home
